export default __webpack_public_path__ + "static/qr-code-4e829980299ae5e77349e86cc53b5ae2.png";